// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9dc8d281","455":"7dc824e8","977":"b5e55621"}[chunkId] + ".chunk.js";
};